import React, { useEffect, useRef } from 'react';
import { LockIcon, UsersIcon, VideoIcon, ActivityIcon } from '../assets/icons/Icons';
import '../styles/why.css';

const whyData = [
  {
    icon: <UsersIcon size={22} />,
    iconClass: 'warm',
    title: 'Expert doctors',
    desc: 'Licensed psychiatrists with 5+ years of clinical expertise in mental healthcare.',
  },
  {
    icon: <LockIcon size={22} />,
    iconClass: 'green',
    title: '100% confidential',
    desc: 'Your privacy is treated with utmost respect. Every conversation is handled with sensitivity and trust.',
  },
  {
    icon: <VideoIcon size={22} />,
    iconClass: 'green',
    title: 'Online or in-person',
    desc: 'Video consultations, or visit our clinic — whatever works for you.',
  },
//   {
//     icon: <ActivityIcon size={22} />,
//     iconClass: 'accent',
//     title: 'Track your progress',
//     desc: 'Visual dashboards showing mood trends, symptom scores, and milestones.',
//   },
  {
    icon: <ActivityIcon size={22} />,
    iconClass: 'accent',
    title: 'Personalized care',
    desc: 'Collaborative care that listens to you — because your voice matters in every step of treatment.',
  },
];

const WhyChooseUs = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));

    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="why-section" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">Why Ishira</span>
          <h2>Care built around you</h2>
          <p>Every detail designed for your comfort and privacy</p>
        </div>

        <div className="why-bento fade-up">
          {whyData.map((item, i) => (
            <div className="why-card" key={i}>
              <div className={`why-icon ${item.iconClass}`}>
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
